import { Button, Card, CardBody, Row, Col } from "reactstrap";
import { useHistory } from "react-router-dom";
import Image from "../../assets/img/sidebar-login.png";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useCookies } from "react-cookie";
import useApi from "../../apiHooks/apiHooks";
import Swal from "sweetalert2";
import { useEffect, useState } from "react";
import displayToast from "functions/displayToast";

const Login = () => {
    const history = useHistory();
    const [showForgotPassword, setShowForgotPassword] = useState(false);
    // Formik
    const initialValues = { username: "", password: "" };
    const forgotPasswordInitialValues = { email: "" };
    const validationSchema = Yup.object({
        username: Yup.string().required("Username is required"),
        password: Yup.string().required("Password is required"),
    });
    const forgotPasswordValidationSchema = Yup.object({
        email: Yup.string()
            .email("Enter a valid email address")
            .required("Email address is required"),
    });

    const onSubmit = (values, { setSubmitting, setFieldError }) => {
        setSubmitting(true);
        onLogin(values, setSubmitting, setFieldError);
    };

    const { login, forgotPassword } = useApi();
    // Login
    const [cookie, setCookie] = useCookies(["userToken"]);

    useEffect(() => {
        if (cookie?.userToken && cookie?.userRole) {
            history.replace(
                cookie?.userRole === "admin"
                    ? "/admin/companies"
                    : "/company/shops"
            );
        }
    }, []);

    const onLogin = async (values, setSubmitting, setFieldError) => {
        let body = {
            identifier: values.username,
            password: values.password,
        };

        try {
            const response = await login(body);
            setSubmitting(false);
            const loginData = response.data;
            setCookie("userRole", loginData.role, {
                path: "/",
            });
            setCookie("userToken", loginData.token, {
                path: "/",
                // maxAge: 3600, // Expires after 1hr
                // sameSite: true,
            });
            if (cookie) {
                displayToast("success", "Login Successful");
                history.push(
                    loginData.role === "admin"
                        ? "/admin/companies"
                        : "/company/shops"
                );
            }
        } catch (err) {
            setSubmitting(false);
            const error = err.response;
            if (error?.status == 401) {
                setFieldError("username", "Invalid Username and/or Password");
                setFieldError("password", "Invalid Username and/or Password");
            } else {
                setFieldError(
                    "username",
                    `An error has occured.${
                        error?.status ? `Error Code: ${error.status}` : ""
                    }`
                );
                setFieldError(
                    "password",
                    `An error has occured.${
                        error?.status ? ` Error Code: ${error.status}` : ""
                    }`
                );
            }
        }
    };

    const onForgotPassword = async (values, { setSubmitting, resetForm }) => {
        try {
            await forgotPassword({ email: values.email });
            displayToast(
                "success",
                "If an account exists for that email, a reset link has been sent"
            );
            resetForm();
            setShowForgotPassword(false);
        } catch (err) {
            const error = err.response;
            displayToast(
                "error",
                error?.data?.error || "Password reset email could not be sent"
            );
        } finally {
            setSubmitting(false);
        }
    };

    // Styles
    const styles = {
        inputContainer: {
            display: "flex",
            flexDirection: "column",
        },
    };
    return (
        <div style={{ overflow: "hidden" }}>
            <Row>
                <Col
                    lg="4"
                    md="7"
                    style={{
                        paddingRight: 0,
                        paddingLeft: 0,
                        height: "100vh",
                    }}
                >
                    <Card
                        className="bg-white"
                        style={{
                            width: "100%",
                            height: "100%",
                            background: `url(${Image})`,
                            backgroundSize: "cover",
                        }}
                    >
                        <CardBody className="px-lg-6 py-lg-7">
                            <h1
                                style={{ color: "#F8F8F8", fontSize: 35 }}
                                className="text-white"
                            >
                                GTOaas
                            </h1>
                            <h4
                                style={{ color: "#F8F8F8", fontSize: 15 }}
                                className="text-white"
                            >
                                LOGIN PORTAL
                            </h4>
                        </CardBody>
                    </Card>
                </Col>
                <Col lg="8" md="7" style={{ paddingRight: 0, paddingLeft: 0 }}>
                    <Card
                        className="bg-white"
                        style={{
                            width: "100%",
                            height: "100%",
                        }}
                    >
                        <CardBody
                            className="px-lg-8 py-lg-7"
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                            }}
                        >
                            <h1>Hi There !</h1>
                            <div className="text-muted mb-4">
                                <h4>
                                    {showForgotPassword
                                        ? "Enter your email address to reset your password"
                                        : "Welcome back, please enter your details"}
                                </h4>
                            </div>

                            {showForgotPassword ? (
                                <Formik
                                    initialValues={forgotPasswordInitialValues}
                                    validationSchema={
                                        forgotPasswordValidationSchema
                                    }
                                    onSubmit={onForgotPassword}
                                >
                                    {(formik) => (
                                        <Form>
                                            <div
                                                className="mt-5"
                                                style={styles.inputContainer}
                                            >
                                                <label htmlFor="email">
                                                    Email Address
                                                </label>
                                                <Field
                                                    name="email"
                                                    id="email"
                                                    type="email"
                                                    disabled={
                                                        formik.isSubmitting
                                                    }
                                                    style={{
                                                        padding: "0.75rem",
                                                    }}
                                                />
                                                <ErrorMessage
                                                    component="div"
                                                    className="red-text"
                                                    name="email"
                                                />
                                            </div>
                                            <Button
                                                disabled={formik.isSubmitting}
                                                style={{
                                                    display: "block",
                                                    width: "100%",
                                                }}
                                                className="mt-5"
                                                color="default"
                                                type="submit"
                                            >
                                                Send Reset Link
                                            </Button>
                                            <Button
                                                color="link"
                                                type="button"
                                                className="mt-3 p-0"
                                                disabled={formik.isSubmitting}
                                                onClick={() =>
                                                    setShowForgotPassword(false)
                                                }
                                            >
                                                Back to login
                                            </Button>
                                        </Form>
                                    )}
                                </Formik>
                            ) : (
                                <Formik
                                    initialValues={initialValues}
                                    validationSchema={validationSchema}
                                    onSubmit={onSubmit}
                                >
                                    {(formik) => (
                                        <Form>
                                            <div
                                                className="mt-5"
                                                style={styles.inputContainer}
                                            >
                                                <label htmlFor="username">
                                                    Username or Email
                                                </label>
                                                <Field
                                                    name="username"
                                                    id="username"
                                                    disabled={
                                                        formik.isSubmitting
                                                    }
                                                    style={{
                                                        padding: "0.75rem",
                                                    }}
                                                />
                                                <ErrorMessage
                                                    component="div"
                                                    className="red-text"
                                                    name="username"
                                                />
                                            </div>
                                            <div
                                                className="mt-5"
                                                style={styles.inputContainer}
                                            >
                                                <label htmlFor="password">
                                                    Password
                                                </label>
                                                <Field
                                                    name="password"
                                                    id="password"
                                                    type="password"
                                                    disabled={
                                                        formik.isSubmitting
                                                    }
                                                    style={{
                                                        padding: "0.75rem",
                                                    }}
                                                />
                                                <ErrorMessage
                                                    component="div"
                                                    className="red-text"
                                                    name="password"
                                                />
                                            </div>
                                            <Button
                                                color="link"
                                                type="button"
                                                className="mt-3 p-0"
                                                disabled={formik.isSubmitting}
                                                onClick={() =>
                                                    setShowForgotPassword(true)
                                                }
                                            >
                                                Forgot password?
                                            </Button>
                                            <Button
                                                disabled={formik.isSubmitting}
                                                style={{
                                                    display: "block",
                                                    width: "100%",
                                                }}
                                                className="mt-5"
                                                color="default"
                                                type="submit"
                                            >
                                                Login
                                            </Button>
                                        </Form>
                                    )}
                                </Formik>
                            )}
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

export default Login;
